import React from 'react'

// eslint-disable-next-line import/prefer-default-export
export function BedroomsSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_5004_20)">
        <path
          d="M7 10.3438V5.1875H13.5C14.0304 5.1875 14.5391 5.38504 14.9142 5.73667C15.2893 6.08831 15.5 6.56522 15.5 7.0625V10.3438"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M1.5 12.6875V3.3125" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.5 10.3438H15.5V12.6875" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 5.1875H1.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_5004_20">
          <rect width="16" height="15" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
